import LoadingButton from 'components/Common/LoadingButton';
import { axiosbaseurl } from 'configure';
import { setUpdatedData } from 'helpers/data_setters';
import React, { useEffect, useState } from 'react'
import { Modal, ModalBody } from "reactstrap"


const AddDocumentMaster = ({ show, setShow, settable_data, type, docId = 0, setDocId }) => {

    // Individual states for each field
    const [documentName, setDocumentName] = useState("");
    const [docDesc, setDocDesc] = useState("");

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    // get existing data
    useEffect(() => {
        const getStatus = async () => {
            try {
                setLoading(true)
                const response = await axiosbaseurl.get(`/document-master/${docId}`);
                if (response.data.success) {
                    setDocumentName(response.data.data.documentName)
                    setDocDesc(response.data.data.documentDescription)
                }
            } catch (error) {
                console.log(error)
            } finally {
                setLoading(false)
            }
        }
        if (docId && type === 'edit')
            getStatus()
    }, [docId])

    // reset states
    useEffect(() => {
        if (!show) {
            setDocumentName("")
            setDocDesc("")
            setError("")
            if (docId)
                setDocId("")
        }
    }, [show])

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            setLoading(true)
            const { data } = await axiosbaseurl[type === 'edit' ? 'put' : 'post'](`/document-master/${type === 'edit' ? `/${docId}` : ''}`, { documentName, documentDescription: docDesc });
            setShow(false)
            settable_data(prev => setUpdatedData(prev, data.data || data.status, type))
        } catch (error) {
            setError(error?.response?.data?.message || error.message)
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal size="md" isOpen={show} toggle={() => setShow(!show)} centered={true}>
            <div className="modal-content">
                <ModalBody className="px-3 ">
                    <div className='d-flex justify-content-between'>
                        <h5 className='text-capitalize'>{type} Document</h5>
                        <button type="button" className="btn-close " onClick={() => setShow(!show)}></button>
                    </div>
                    <div>
                        {
                            error && <div className="alert alert-danger">{error}</div>
                        }
                    </div>
                    <form onSubmit={handleSubmit} className='mt-4'>
                        <div className="mb-3">
                            <label>Document Name <span className='text-danger'>*</span></label>
                            <input
                                type="text"
                                placeholder='Enter Document Name '
                                value={documentName}
                                onChange={(e) => setDocumentName(e.target.value)}
                                className="form-control input-field"
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label>Document Description</label>
                            <textarea
                                placeholder='Enter Description here..'
                                value={docDesc}
                                onChange={(e) => setDocDesc(e.target.value)}
                                className="form-control input-field"
                                rows={3}
                            />
                        </div>

                        <div className='text-center mt-4'>
                            <LoadingButton loading={loading} />
                        </div>

                    </form>

                </ModalBody>
            </div>
        </Modal>
    )
}

export default AddDocumentMaster